import clsx from "clsx";
import { memo } from "react";

import classes from "../../styles.module.scss";

import { Filter } from "@components/molecules/filter";
import type { ITableFilterSearchProps } from "@components/organisms/pageTable";
import { TableSearch } from "@components/molecules/tableSearch";
import { Grid } from "@components/atoms/Grid";

export const TableFilterSearch = memo(function TableFilterSearch({
  filterProps,
  searchProps,
  actions,
  placeholder,
}: ITableFilterSearchProps) {
  return (
    <div className={clsx(classes.pageTable__filterSearch)}>
      {filterProps?.options && filterProps?.options?.length > 0 && (
        <Filter
          options={filterProps.options}
          value={filterProps.value}
          index={filterProps.index}
          onFilterSelect={filterProps.onFilterSelect}
          containerClassname={filterProps.containerClassname}
          contentClassname={filterProps.contentClassname}
          setToUrl={filterProps.setToUrl}
        />
      )}
      <TableSearch
        onChange={searchProps?.onChange || (() => {})}
        value={searchProps?.value}
        placeholder={placeholder}
      />
      {actions && (
        <Grid.Button className={clsx(classes.pageTable__gridButton)}>
          {actions}
        </Grid.Button>
      )}
    </div>
  );
});
